export default __webpack_public_path__ + "static/media/devices.a68f01fe.png";